// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getOtherCreditTypes} from '../../shared/repositories';

export const readOtherCreditDescriptions = (claimTypeKey, spaType) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getOtherCreditTypes(claimTypeKey, spaType);

            dispatch({
                data,
                type: actions.UPDATE_OTHER_CREDIT_TYPES_COLLECTION
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/other-credit-descriptions.js